// extracted by mini-css-extract-plugin
module.exports = {"blockNav":"block-nav_blockNav__3iu8h"};